import { schema } from "normalizr";
export const comment = new schema.Entity("comments");
export const document = new schema.Entity("documents", {
  comments: [comment]
}, {
  idAttribute: "documentId"
});
export const classificationListSchema = new schema.Entity("classifications", {
  documents: [document]
}, {
  idAttribute: "documentRequestId"
});
export const sampleDocument = new schema.Entity("sampleDocuments", {
  documents: [document]
}, {
  idAttribute: "documentId"
});
export const documentRequest = new schema.Entity("documentRequests", {
  sampleDocuments: [sampleDocument]
}, {
  idAttribute: "id"
});
export const documentRequestListSchema = new schema.Entity("documentRequestLists", {
  documentRequests: [documentRequest]
}, {
  idAttribute: "name"
});
export const documentRequestTemplate = new schema.Entity("documentRequestTemplate");
export const documentType = new schema.Entity("documentTypes");
export const documentTypesSchema = new schema.Entity("documentTypes", {
  documents: [documentType]
}, {
  idAttribute: "documentTypeId"
});
export const documentRequestTemplateSchema = new schema.Entity("documentRequestTemplates", {
  documentRequestTemplates: [documentRequestTemplate]
}, {
  idAttribute: "id"
});
export const documentLabel = new schema.Entity("documentLabels");
export const documentLabelsSchema = new schema.Entity("documentLabels", {
  documentLabels: [documentLabel]
}, {
  idAttribute: "id"
});